var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-description',{attrs:{"path":[
      { label: _vm.$t('data.sidebar_preferences'), route: 'preferences' },
      { label: 'Gestion des utilisateurs', route: 'users' },
    ]}}),(_vm.path == '')?_c('Preferences'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }